import { render } from "./logoutView.vue?vue&type=template&id=32901f75"
import script from "./logoutView.vue?vue&type=script&lang=js"
export * from "./logoutView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__